import { render, staticRenderFns } from "./QuestionListPage.vue?vue&type=template&id=749d5bee&scoped=true&"
import script from "./QuestionListPage.vue?vue&type=script&lang=js&"
export * from "./QuestionListPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionListPage.vue?vue&type=style&index=0&id=749d5bee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d5bee",
  null
  
)

export default component.exports